// The row a task occupies: its series (`ics`) plus the occurrence within that series.
//
// Sliced to the DATE, for the same reason selectors' `occurrenceKey` is. The two
// fields that answer "which occurrence" are not formatted alike: `recurrence_id`
// holds a bare date, while `start` -- the fallback on an occurrence that has never
// been edited -- carries a time on a timed task. Compared whole, one occurrence
// therefore produced two different identifiers depending on which field supplied it,
// and callers that look a row up by identifier missed it.
//
// The reducer's `confirm: 'this'` branch appends whatever it cannot find, so a miss
// did not fail loudly -- it added a phantom row. Completing a subtask under a
// repeating parent hit this every time: the request substitutes the PARENT
// occurrence's stamp (TaskItem's `toggle`, and childReorderPayload for a drag), which
// agrees with the child's to the date -- all `childrenForOccurrence` compares -- but
// not beyond it. So a duplicate subtask appeared under the parent (ARTFLT-1576).
//
// Safe at date granularity because a series cannot produce two occurrences on one
// day: the repeat rule offers DAILY, WEEKLY, MONTHLY and YEARLY only. Two rows that
// now share an identifier are the same occurrence, and the duplicates already written
// into a store by this bug collapse back into one.
export const identifierForTask = ({ id, ics, start, recurrence_id }) => {
  if (id?.startsWith('temp-')) return id;
  return `${ics}/${(recurrence_id || start || '').substring(0, 10)}`;
};
